export default {
  havas: {
    pdv: {
      colorIcon: 'transparent',
      widthIcon: 70,
      heightIcon: 70,
      anchorIcon: false,
      getGoogleAnchor: (height, width) => new google.maps.Point(width / 2, height / 2),
    },
    pdvConcurent: {
      widthIcon: 30,
      heightIcon: 30,
    }
  },
  default: {
    pdv: {
      colorIcon: 'red',
      widthIcon: 45,
      heightIcon: 45,
      anchorIcon: true,
      getGoogleAnchor: (height, width) => new google.maps.Point(width / 2, height),
    },
    pdvConcurent: {
      widthIcon: 28,
      heightIcon: 33,
    }
  }
}
